import { render, staticRenderFns } from "./PaymentRequisitionDetail.vue?vue&type=template&id=4e567752&"
import script from "./PaymentRequisitionDetail.vue?vue&type=script&lang=ts&"
export * from "./PaymentRequisitionDetail.vue?vue&type=script&lang=ts&"
import style0 from "./PaymentRequisitionDetail.vue?vue&type=style&index=0&id=4e567752&prod&lang=sass&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports